import { render, staticRenderFns } from "./LaporanRegisterObstetriPage.vue?vue&type=template&id=99dc03d2&scoped=true&"
import script from "./LaporanRegisterObstetriPage.vue?vue&type=script&lang=ts&"
export * from "./LaporanRegisterObstetriPage.vue?vue&type=script&lang=ts&"
import style0 from "./LaporanRegisterObstetriPage.vue?vue&type=style&index=0&id=99dc03d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dc03d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VChip,VContainer,VIcon,VPagination,VSelect,VSpacer})
